import { Redirect, Route } from 'react-router-dom'
import React from 'react'
import * as PropTypes from 'prop-types'

function PrivateRoute ({ component: Component, isOpen, redirectPath, componentProps, ...rest }) {
  return (
    <Route
      {...rest}
      render={props => {
        return isOpen ? <Component {...props} {...componentProps} /> : (
          <Redirect
            to={{
              pathname: redirectPath,
              state: { from: props.location }
            }}
          />
        )
      }}
    />
  )
}

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  redirectPath: PropTypes.string.isRequired,
  location: PropTypes.object
}

export default PrivateRoute
